<template>
  <div class="recent-actions">
    <div class="search">
      <tol-type-ahead
        :search-params="{
          url: `/event-log/user-activity`,
          searchKeys: ['searchParam'],
          urlParams: {
            recordsPerPage: userActivityPageLimit,
            offset: userActivityOffset,
            sortBy: userActivitySortOrder,
            sortDirection: userActivitySortDirection
          }
        }"
        :results-in-dropdown="false"
        menu-label="Search user activity logs"
        @filtered="onFiltered($event)"
      >
      </tol-type-ahead>
    </div>
  </div>
</template>

<script>
import TolTypeAhead from '@/app/components/TolTypeAhead';
import {
  UserActivityGetters,
  UserActivityActions
} from '@/app/features/user-activity/user-activity.keys';
export default {
  name: 'ActivityActions',
  components: {
    TolTypeAhead
  },

  computed: {
    userActivityPageLimit() {
      return this.$store.getters[UserActivityGetters.UserActivityPerPage];
    },
    userId() {
      return this.$store.state.currentUser ? this.$store.state.currentUser.id : null;
    },
    userActivityOffset() {
      return this.$store.getters[UserActivityGetters.UserActivityListingOffset];
    },
    userActivitySortOrder() {
      return this.$store.getters[UserActivityGetters.SortBy];
    },
    userActivitySortDirection() {
      return this.$store.getters[UserActivityGetters.SortDirection];
    }
  },
  updated() {
    if (!this.userId) {
      this.userId = this.$store.state.currentUser.id;
    }
  },
  methods: {
    onFiltered(results) {
      this.$store.dispatch(UserActivityActions.FilterUserActivity, results);
    },
    onDeleteAll() {
      this.$store.dispatch(UserActivityActions.DeleteUserActivity, {
        userId: this.userId,
        recentItemId: null,
        all: true
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../styles/colors.scss';
@import '../../../styles/variables.scss';

.recent-actions {
  display: flex;
  align-items: center;
  background-color: $background-level-2;
  padding: 60px;

  .search {
    display: flex;
    flex-basis: 100%;
    .search-container {
      flex-basis: 100%;
    }
  }
}
</style>
